
import React, { useState,useEffect } from 'react';
import { query, collection, getDocs, where,serverTimestamp,addDoc,getDoc,doc,Timestamp,orderBy,setDoc,updateDoc } from "firebase/firestore";
import Select from 'react-select'

import { Table } from 'react-bootstrap';
import { db } from '../auth/UsersConfig/Authfirebase';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import ProgressLoad from '../Tools/ProgressLoad';
import { ConvertObjToArray } from '../Tools/Converts';
import Alert from 'react-bootstrap/Alert';
import '../StyleBase/base.css'
import BsHead from '../Tools/BsHead';
import UploadImg from './UploadImg';
const Catalogo = () => {
    const [MdShowCatalogos,setMdShowCatalogos]=useState(false);
    const [ProgrLoading,setProgrLoading]=useState(false);
    const [Nombre, setNombre] = useState("");
    const [Desc, setDesc] = useState("");
    const [Listado, setListado] = useState();
    const [docID,setDocID]=useState();
     const [RowID,setRowID]=useState();
    const [TablaCatalogos,setTablaCatalogos]=useState();
    const [ModoEdicion,setModoEdicion]=useState(false);
    const [Errorcatalogo,setErrorcatalogo]=useState("");
   const Data_Listado = [ {value:'2',label:' Categorias'}
  ];
    const columns=[" No "," Nombre ","Descripcion","Activo","Editar"]
    const handleQuestionChange = (event) => {
      setNombre(event.target.value);
    };
    const handleQuestionChangeDesc = (event) => {
      setDesc (event.target.value);
    };
    
  
  
      const AgregarCatalogos = () => {
        if (Nombre.length < 2) {
       setErrorcatalogo("Especificar nombre");
            return;
          }
          if (Desc.length < 2) {
            setErrorcatalogo("Especificar Descripcion");
                 return;
               }
         
        let No =TablaCatalogos===undefined?0:TablaCatalogos?.length;
      const NuevaOpcion= {[(No+1)]:{Id:(No+1),Nom:Nombre,Desc:Desc,Logo:{Url:'',UrlMin:'',chRec:serverTimestamp()}}};
          const SelectCollection = doc(db, "Catalogos", docID);
          setDoc(SelectCollection,{List:NuevaOpcion},{merge:true}).then(()=>{
              setTablaCatalogos(current => [...current, NuevaOpcion[(No+1)]]);
              setMdShowCatalogos(false);
              setNombre('');
              setDesc('');
           }).catch((error)=>{
               alert(error.message)
             });
      };
  
      const SeleccionarListado = (opcion) => {
        setListado(opcion);
      }
      const HideLoading=()=> {
        setTimeout(() => { setProgrLoading(false); }, 3000);
       }
  
       const ListadoBase=async()=>{
        try {
          if(Listado!=undefined){
          const collectRef = collection(db,"Catalogos");
          const queryRef = query(collectRef, where('Activo', '==', true),where('NoList', '==',parseInt(Listado.value)));
          const snapshot = await getDocs(queryRef);
          if (snapshot.size === 0) {
            IniciaCatalogos();
          } else {
            snapshot.forEach(doc => {
                setDocID(doc.id);
                console.log(doc.data().List);
                setTablaCatalogos(ConvertObjToArray(doc.data().List));
             })
             console.log(TablaCatalogos);
        }}
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
const actualizarCampoNom = (id, nuevoValor) => {
  setTablaCatalogos(prevDataArray => {
    return prevDataArray.map(obj => {
      if (parseInt(obj.Id) ===parseInt( id)) {
        return { ...obj, Nom: nuevoValor,Desc:Desc };
      }
      return obj;
    });
  });
};
      const  IniciaCatalogos = async(a) => {
        const time= serverTimestamp();
        const NuevoCatalogos= {Activo:true,AddRec:time,
        NoList: parseInt(Listado.value),Nom:Listado.label,List:{}
         }
        const Collect=collection(db, "Catalogos")/*Conectar a la coleccion*/
        const docRef = await addDoc(Collect, NuevoCatalogos).then((re)=>
          {
        /*Obtener el id del documento*/
        setDocID(re.id);
        setTablaCatalogos([]);
            HideLoading();
          }
        )  
        };
      useEffect(() => { ListadoBase()},[Listado]);

      const EditarRegistro = (No,Nom,Desc) => {
        setRowID(No);
        setModoEdicion(true);
        setMdShowCatalogos(true);
        setNombre(Nom);
        setDesc(Desc);
        // Lógica para manejar el evento onChange y utilizar el parámetro
      console.log("Editar");
      };
      
       const UpdateActualizarCatalogoNombre = async() => {
         if (Nombre.length < 2) {
         setErrorcatalogo("Especificar nombre");
                                     return;
            }
          setProgrLoading(true)
      const CollectCatalogos = doc(db, "Catalogos", docID);

         await updateDoc(CollectCatalogos, {  [`List.${RowID}.Nom`]:Nombre,[`List.${RowID}.Desc`]:Desc }).then(()=>{
          setProgrLoading(false);
          actualizarCampoNom(RowID,Nombre);
        });
                                }

    return (
      <div className='ContainerBody'>
  
  
        <div className='ContainerRow'>      <label>Catálogos:</label>
           <Select options={Data_Listado} placeholder="Seleccionar.." className='LtEstados'  defaultValue={Listado} onChange={SeleccionarListado}/>
           </div>
           <div className='ContainerRow'> 
           <button variant="primary"  onClick={() => { setModoEdicion(false);setMdShowCatalogos(true);}} className="bsButtonMd">
      ➕Nuevo
              </button></div>
              <Table striped bordered hover variant="light" responsive="lg">
                                                          <thead>  <BsHead dataHeader={columns} /> </thead>
                                                          <tbody>
                                                          {
                                                              TablaCatalogos?.map((doc,i) => (
                                                                <tr key={i}>
                                                                    <td>{doc.Id}</td>
                                                                      <td>{doc.Nom}</td>
                                                                      <td>{doc.Desc}</td>
                                                                      <td><UploadImg DocID={docID} NoImg={doc.Id} detalle={doc.Logo} key={doc.Id} /></td>
                                                                      <td>{doc.Act} </td>
                                                                      <td><button variant="primary" onClick={() => EditarRegistro(doc.Id,doc.Nom,doc.Desc)} className="bsButtonMd" >Editar</button></td>
                                                                  </tr>
                                                              ))
                                                          }
                                                            </tbody>
                                          </Table>
  
     
  
  
        <Modal show={MdShowCatalogos}  fullscreen="lg-down" onHide={() => setMdShowCatalogos(false)}>
      <Modal.Header closeButton>
        <Modal.Title><Button variant="outline-info" onClick={()=> setMdShowCatalogos(false)}> ❰ Regresar</Button> Catálogo de {Listado?.label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Alert variant="danger" onClose={() => setErrorcatalogo("")} dismissible show={Errorcatalogo.length>0?true:false} className="AlertError">
            <Alert.Heading>Revisar!</Alert.Heading>
            <p>
        {Errorcatalogo}
            </p>
          </Alert>
          <div className='RowContent'>
      <label>
          Nombre:
          <input type="text" value={Nombre} onChange={handleQuestionChange} className='bsInput' />
        </label></div>
        <div className='RowContent'>
        <label>
  Descripción:
  <textarea value={Desc} onChange={handleQuestionChangeDesc}  style={{ width: '100%', height: '4em' }}/>
</label>
</div>
        {ModoEdicion===false?
        <button  className="bsButton"  onClick={AgregarCatalogos}  > Agregar </button>:
        <button  className="bsButton"  onClick={UpdateActualizarCatalogoNombre}  > Actualizar </button>
        }
        </Modal.Body>
    </Modal>
    {ProgrLoading===true? <ProgressLoad/>:"" } 
      </div>
    );
  };
  
  export default Catalogo;
  